import * as React from 'react';
import Stack from '@mui/material/Stack';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import MailIcon from '@mui/icons-material/Mail';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Stack": Stack, "@mui/material/Badge": Badge, "@mui/material/IconButton": IconButton, "@mui/material/Switch": Switch, "@mui/material/FormControlLabel": FormControlLabel, "@mui/icons-material/Mail": MailIcon } } });
export default ClientProvider;
